<ngx-loading [show]="showSpinner"></ngx-loading>

<div class="card page-content">
    <div class="row justify-content-center">
        <div class="col-md-12">
            <div class="card">
                <div class="modal-header">
                    <h1>{{'usersModule.newUser' | translate}}</h1>
                    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="form-control-label text-uppercase">
                                    {{
'usersModule.firstNameCreation'
                                    |
                                    translate
                                    }}
                                </label>
                                <input type="text" name="firstName" class="form-control text-uppercase"
                                        [(ngModel)]="newUser.firstName" />
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="form-control-label text-uppercase">
                                    {{
'usersModule.lastNameCreation' |
                                    translate
                                    }}
                                </label>
                                <input type="text" name="lastName" class="form-control text-uppercase"
                                    [(ngModel)]="newUser.lastName" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="form-control-label text-uppercase">
                                    {{
'usersModule.email' |
                                    translate
                                    }}
                                </label>
                                <input type="text" name="email" class="form-control text-uppercase"
                                    (keydown.space)="$event.preventDefault();"
                                    [(ngModel)]="newUser.email" />
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="form-control-label text-uppercase">
                                    {{
                                        'usersModule.systemAccountIdSintra' | translate
                                    }}
                                </label>
                                <input type="text" name="SystemAccountIdSintra" class="form-control text-uppercase"
                                    (keydown.space)="$event.preventDefault();"
                                    [(ngModel)]="newUser.systemAccountIdSintra" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="" class="form-control-label text-uppercase">
                                    {{'usersModule.role' | translate}}
                                </label>
                                <select class="form-control form-select form-control-sm pt-0 pb-0 small-height"
                                        [(ngModel)]="newUser.role">
                                    <option *ngFor="let role of roles" [value]="role">
                                        {{translate.instant(role) | uppercase}}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer mt-3">
                    <div class="row">
                        <div class="col-md-12 text-right">
                            <button class="btn btn-success mr-3" (click)="addNewUser()" [disabled]="submitting">
                                {{
'add'
                                | translate
                                }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>